import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import CUtils from './utils/c.utils-0.1.0'; // 工具类
import Wxshare from '@/utils/c.wxshare'; // 工具类

// 全局引入按需引入UI库 vant
import '@/plugins/vant';
// 引入全局样式
import '@/assets/css/index.scss';
// 移动端适配
import 'amfe-flexible';
// import Vconsole from 'vconsole'

// if (process.env.VUE_APP_ENV === 'int') {
//   window.vc = new Vconsole()
// }

Vue.prototype.$utils = CUtils;
Vue.prototype.$wxshare = Wxshare;

// filters
import './filters';
Vue.config.productionTip = false;
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});